export const imageListToLoad = [
  //default image
  ['default', 'images/default.jpg'],

  ['table1', 'images/wooden_table.png'],
  ['map1', 'images/map_1.gif'],
];
